import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=335dbdc2&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=335dbdc2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335dbdc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335dbdc2')) {
      api.createRecord('335dbdc2', component.options)
    } else {
      api.reload('335dbdc2', component.options)
    }
    module.hot.accept("./certificate.vue?vue&type=template&id=335dbdc2&scoped=true", function () {
      api.rerender('335dbdc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appSet/components/certificate.vue"
export default component.exports